import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Button, MiniLoader } from '@pwc/pwc-deals-ui';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getLoadingInProcess,
  IngestionThunk2,
} from '../../../../common/engine/reducers/StructuredAnalysisSlice';
import { intersect } from '../../common/utils';
import {
  addAnalysisTypePath,
  addStructuredAnalysisPathForDocument,
} from '../../../../common/services/urlService';
import styles from './IngestStructuredDocumentButton.module.scss';

const ButtonLabelFactory = (t, documentCodes) => {
  const buttonLabels = {
    PandLQofE: 'newQualityofEarnings',
    BsVNWC: 'newNetWorkingCapital',
    DDL: 'newDebtAndDebtLike',
  };
  const labelKey = documentCodes.join('');
  return labelKey in buttonLabels ? t(buttonLabels[labelKey]) : 'Add';
};

const IngestStructuredAnalysisButton = ({
  documentCodes,
  projectId,
  route,
  disabled,
  onIngestion,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const loadingDocuments = useSelector(getLoadingInProcess);
  const loading = intersect(loadingDocuments, documentCodes).length > 0;
  const message = loading ? '' : ButtonLabelFactory(t, documentCodes);

  const onIngestionPostIngestStructuredDocument = () => {
    if (loading) {
      return;
    }
    dispatch(IngestionThunk2(projectId, documentCodes)).then((data) => {
      if (data?.length > 0) {
        const addPageUrl = addStructuredAnalysisPathForDocument(
          projectId,
          route
        );
        history.replace(addPageUrl, {
          prevPath: addAnalysisTypePath(projectId),
        });
      }
    });
  };

  return (
    <Button
      className={classnames(
        loading && 'button-outline',
        loading && styles['button-loading']
      )}
      disabled={disabled}
      data-testid={`ingest-analysis-button-${documentCodes.join('-')}`}
      onClick={onIngestion || onIngestionPostIngestStructuredDocument}
    >
      {loading && <MiniLoader />} {message}
    </Button>
  );
};

IngestStructuredAnalysisButton.propTypes = {
  documentCodes: PropTypes.arrayOf(PropTypes.string),
};

IngestStructuredAnalysisButton.defaultProps = {
  documentCodes: [],
};

export default IngestStructuredAnalysisButton;
